import React, { memo } from 'react';
import type { FunctionComponent } from 'react';
import './MailToLink.scss';
import { getClasses } from '@utils';
interface MailToLinkProps {
	email: string;
	bold?: boolean;
	label?: string;
}

export const MailToLink: FunctionComponent<MailToLinkProps> = memo(({ email, label, bold = false }) => {
	const mailToClassNameObj = {
		'mail-to-link': true,
		'mail-to-link__bold': bold,
	};

	return (
		<a className={getClasses(mailToClassNameObj)} href={`mailto:${email}`}>
			{label || email}
		</a>
	);
});
